// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_IObm7","logo_box":"index_logo_box_02Inu","breadcrumbs":"index_breadcrumbs_-KpUl"};